module.exports = __webpack_public_path__ + "img/NZDUSD.2ac53dfc.png";